import type { FunnelStep, ResponseBreakdown } from "../api";

type Args = {
  steps: FunnelStep[];
  // Per-question responses, fetched lazily and keyed by question_id. The funnel
  // steps no longer carry inline responses (they load separately), so the CSV
  // is assembled from this map joined to each step for denominators/labels.
  breakdowns: Record<string, ResponseBreakdown[]>;
  optionLabels: Record<string, Record<string, string>>;
};

function csvCell(value: string | number): string {
  const s = String(value);
  if (s.includes(",") || s.includes('"') || s.includes("\n")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function buildBreakdownCsv({
  steps,
  breakdowns,
  optionLabels,
}: Args): string {
  const header =
    "question_id,answer_id,label,count,pct_of_answered,pct_of_started,denominator_answered,denominator_started";
  const out: string[] = [header];
  for (const s of steps) {
    if (s.breakdown_kind !== "options") continue;
    const responses = breakdowns[s.question_id ?? ""] ?? [];
    for (const r of responses) {
      const label =
        optionLabels[s.question_id ?? ""]?.[r.answer_id] ?? r.answer_id;
      out.push(
        [
          csvCell(s.question_id ?? ""),
          csvCell(r.answer_id),
          csvCell(label),
          csvCell(r.count),
          csvCell(r.pct_of_answered),
          csvCell(r.pct_of_started),
          csvCell(s.denominator_answered),
          csvCell(s.denominator_started),
        ].join(","),
      );
    }
  }
  return out.join("\n") + "\n";
}
